<section class="box">
  <div class="tile-progress bg-white text-left">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <label>Select Date Range</label>
        <ngx-mat-drp (selectedDateRangeChanged)="updateRange($event)" [options]="options" #dateRangePicker>
        </ngx-mat-drp>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <label>Select Account</label>
        <ng-select [items]="accounts" (change)="getStatistics()" name="accounts" placeholder="Select Account"
          bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="accountId">
        </ng-select>
      </div>
    </div>
  </div>

  <!--<div *ngIf="datewisePayments!=null && datewisePayments.length>0">
    <div class="card-header">
      Payment statistics by filtered date
      <span style="float:right;">{{filteredTime.startDate | date:'MMM d, y'}} -
        {{filteredTime.endDate | date:'MMM d, y'}}</span>
    </div>
    <div class="card-body" style="background: #FFF;padding: 15px;">
      <app-amcharts [data]="datewisePayments" [valueField]="'amount'" [titleField]="'paymentDate'"
        [id]="'datewisechart'" [title]="'Datewise payment statistics'" [height]="400" [type]="'line'">
      </app-amcharts>
    </div>
  </div>-->

  <div class="row" style="margin-top:15px;">
    <div class="col-md-6 col-sm-12 col-xs-12 col-lg-6" *ngIf="datewisePayments!=null && datewisePayments.length>0">
      <div class="card-header">
        <span *ngIf="accountId==null">
          Payment split by account
        </span>
        <span *ngIf="accountId!=null">
          Payment split by user
        </span>
        <!--<span style="float:right;">{{filteredTime.startDate | date:'MMM d, y'}} -
          {{filteredTime.endDate | date:'MMM d, y'}}</span>-->
          <span style="float:right;">{{filteredTime.startDate | date:customDateFormat}} -
            {{filteredTime.endDate | date:customDateFormat}}</span>
      </div>
      <div class="card-body" style="background: #FFF;padding: 15px;">
        <app-amcharts [data]="accountwisePayments" [valueField]="'fieldValue'" [titleField]="'fieldName'"
          [id]="'accountlevel'" [title]="'Accountwise payment statistics'" [height]="274" [type]="'pie'">
        </app-amcharts>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 col-xs-12 col-lg-6" *ngIf="datewisePayments!=null && datewisePayments.length>0">
      <div class="card-header">
        <span *ngIf="accountId==null">
          Payment split by package name
        </span>
        <span *ngIf="accountId!=null">
          Payment split by package name
        </span>
        <!--<span style="float:right;">{{filteredTime.startDate | date:'MMM d, y'}} -
          {{filteredTime.endDate | date:'MMM d, y'}}</span>-->
          <span style="float:right;">{{filteredTime.startDate | date:customDateFormat}} -
          {{filteredTime.endDate | date:customDateFormat}}</span>
      </div>
      <div class="card-body" style="background: #FFF;padding: 15px;">
        <app-amcharts [data]="packagewisePayments" [valueField]="'fieldValue'" [titleField]="'fieldName'"
          [id]="'packagelevel'" [title]="'Packagewise payment statistics'" [height]="274" [type]="'pie'">
        </app-amcharts>
      </div>
    </div>
  </div>
</section>